import { AppBar, List, ListItem, styled } from '@mui/material'

export const StyledAppBar = styled(AppBar)({
  backgroundColor: 'black',
  padding: '15px 10px',
})

export const StyledListItem = styled(ListItem)({
  display: 'flex',
  flexDirection: 'column',
})

export const StyledList = styled(List)({})

export const StyledNav = styled('nav')({})
